import React, {Component, PropTypes} from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {toPX} from 'utils';

const LOREM_IPSUM = `
Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis hendrerit metus aliquam tellus facilisis, in rhoncus
tellus aliquet. Nullam id elementum odio. Sed sollicitudin dapibus ligula, a aliquam orci fermentum non. In quam risus,
consequat et pellentesque non, lacinia in ligula. Sed ac enim lobortis, suscipit neque ut, consectetur neque. Cras
accumsan efficitur ipsum in congue. Nullam ultricies, enim at dictum tincidunt, elit metus tincidunt sem, nec facilisis
dolor augue quis ante. Sed nec augue ex. Curabitur condimentum pulvinar enim, eget condimentum nisl convallis et.
Suspendisse potenti. Nunc non tellus elit. Donec ornare massa eu felis pellentesque malesuada. Donec pharetra, massa
sed sodales facilisis, arcu elit vehicula dui, eget consectetur risus sapien a nunc. Donec luctus magna ac dictum.
`;

const SIDEBAR_WIDTH = 370;

export default class MockContent extends Component {
    static propTypes = {
        video: PropTypes.node.isRequired,
        mobile: PropTypes.bool.isRequired,
        videoSize: PropTypes.number.isRequired,
        videoSizeOptions: ImmutablePropTypes.list.isRequired,
        domContainer: PropTypes.node,
        domContainerSize: PropTypes.number.isRequired,
    };

    getContainerStyle() {
        if (this.props.mobile) return {};

        const {domContainer, domContainerSize, videoSize, videoSizeOptions} = this.props;
        const domContainerWidth = domContainer ? domContainerSize : SIDEBAR_WIDTH;
        const videoWidth = Math.max(videoSize, videoSizeOptions.getIn([2, 'value']));
        return {width: toPX(videoWidth + domContainerWidth + 60)};
    }

    render() {
        const containerStyle = this.getContainerStyle();

        return (
            <div className='mock-content-wrapper'>
                <div className='mock-header'>
                    <div className='mock-container' style={containerStyle}>
                        <div className='mock-logo' />
                        <ul className='mock-menu'>
                            <li>Home</li>
                            <li>About Us</li>
                            <li>Services</li>
                            <li>Contact</li>
                        </ul>
                        <div className='mock-menu-toggle'>
                            <img src='images/test-page/menu.svg' alt='' />
                        </div>
                    </div>
                </div>
                <div className='mock-title'>
                    <h1 className='mock-h1'>Test Page</h1>
                </div>
                <div className='mock-content'>
                    <div className='mock-container' style={containerStyle}>
                        <div className='mock-main'>
                            <h1 className='mock-h1'>
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                            </h1>
                            <h2 className='mock-h2'>
                                Etiam sollicitudin quam id massa tincidunt pulvinar. Curabitur tempus velit et
                                phare lacinia. Nunc ante leo, efficitur sit amet dolor a.
                            </h2>
                            {this.props.video}
                        </div>
                        {this.props.domContainer && (
                            <div className='mock-aside'>
                                {this.props.domContainer}
                            </div>
                        )}
                    </div>
                    <div className='mock-container' style={containerStyle}>
                        <div className='mock-main'>
                            <p className='mock-p'>{LOREM_IPSUM}</p>
                            <p className='mock-p'>{LOREM_IPSUM}</p>
                        </div>
                    </div>
                </div>
                <div className='mock-footer'>
                    <div className='mock-container' style={containerStyle}>
                        <div className='mock-footer-logo'>
                            <img src='images/test-page/logo-white.svg' alt='' />
                            <p><strong>Test Page - Mock Content</strong></p>
                        </div>
                        <div className='mock-footer-social'>
                            <p>Follow Us</p>
                            <img src='images/test-page/social-icons.svg' alt='' />
                        </div>
                    </div>
                    <div className='mock-copyright'>
                        <div className='mock-container' style={containerStyle}>
                            <p>Copyright © {new Date().getFullYear()} cielo24, Inc. All Rights Reserved.</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/test-page/mock-content.js